import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
        href=""
        ref={ref}
        onClick={e => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
    </a>
));


function HeaderProfile() {


    return (
        <>
            <Dropdown>
                <Dropdown.Toggle as={CustomToggle}>
                    <img src={require('./../../images/profile/pic1.jpg')} width="20" alt=""/>
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdown-menu-right" alignRight>
                    <Link to={"./app-profile"} className="dropdown-item">
                        <i className="icon-user"></i>
                        <span className="ml-2">Profile </span>
                    </Link>
                    <Link to={"./email-inbox"} className="dropdown-item">
                        <i className="icon-envelope-open"></i>
                        <span className="ml-2">Inbox </span>
                    </Link>
                    <Link onClick={()=>localStorage.removeItem('loginToken')} to={"/login"} className="dropdown-item">
                        <i className="icon-key"></i>
                        <span className="ml-2">Logout </span>
                    </Link>

                </Dropdown.Menu>
            </Dropdown>
        </>
    );
}

export default HeaderProfile;


